import { useContext, useState } from "react";
import { CartContext } from "../Cart/CartContext";

const services = [
  {
    id: 1,
    title: "80G/12A Provisional Registration",
    code: "S01",
    description:
      "80G12A provisional registration is the first step towards the growth of your NGO.",
    price: 5310,
  },
  {
    id: 2,
    title: "80G/12A Final Registration",
    code: "S02",
    description:
      "80G12A final registration is mandatory for all provisionally registered 80G/12A organisations.",
    price: 26550,
  },
  {
    id: 3,
    title: "CSR Registration",
    code: "S03",
    description:
      "CSR Registration is mandatory for charitable organisations to obtain CSR Donations.",
    price: 5310,
  },
  {
    id: 4,
    title: "Niti Aayog Registration/ NGO Darpan",
    code: "S04",
    description:
      "Helps the trust to get eligibility for various government schemes.",
    price: 2655,
  },
  {
    id: 5,
    title: "Form 10BD Filing",
    code: "S05",
    description:
      "Form 10BD is required to be filed by every NGO holding 80G/12A Registration.",
    price: "Get A Quote",
  },
  {
    id: 6,
    title: "Section - 8 Company",
    code: "S06",
    description:
      "A Non-Profit Organization registered under Companies Act 2013.",
    price: 7434,
  },

  {
    id: 7,
    title: "Private Limited Company",
    service_code: "S07",
    description:
      "The Private Limited Company offers limited liability protection to shareholders and facilitates seamless power transfer.",
    price: 7434,
    inclusive: true,
  },
  {
    id: 8,
    title: "One Person Company",
    service_code: "S08",
    description:
      "Registering a One-Person Company (OPC) is favored among entrepreneurs who desire limited liability and a distinct legal identity.",
    price: 7434,
    inclusive: true,
  },
  {
    id: 9,
    title: "DPIIT - Startup India Registration",
    service_code: "S09",
    description:
      "This registration gives recognition to your business as a startup by the Department for Promotion of Industry and Internal Trade.",
    price: 7434,
    inclusive: true,
  },
  {
    id: 10,
    title: "Trademark Registration",
    service_code: "S10",
    description:
      "Trademark registration is the most important registration for any brand or business.",
    price: null,
    option: "Select Option",
  },
  {
    id: 11,
    title: "FSSAI",
    service_code: "S11",
    description:
      "The Food Safety and Standards Authority of India (FSSAI) is a statutory body under the Ministry of Health and Family Welfare, Government of India.",
    price: null,
    option: "Get A Quote",
  },
  {
    id: 12,
    title: "GST Registration / GST Amendment",
    service_code: "S12",
    description:
      "GST registration becomes mandatory if a person or entity sells goods or services beyond a certain turnover. GST Amendment: changes in the core or non-core fields of GST registration.",
    price: null,
    option: "Select Option",
  },
  {
    id: 13,
    title: "GeM Registration",
    service_code: "S13",
    description:
      "The Government e Marketplace (GeM) is an online platform for public procurement in India.",
    price: 3186,
    inclusive: true,
  },
  {
    id: 14,
    title: "Import Export Code",
    service_code: "S14",
    description:
      "The Import Export Code is a mandatory registration requirement for businesses that import or export goods / services.",
    price: null,
    option: "Select Option",
  },
  {
    id: 15,
    title: "Director KYC",
    service_code: "S15",
    description:
      "Director KYC is mandated by The Companies Act, 2013, and failing to comply can cost Rs. 5,000 penalty.",
    price: null,
    option: "Select Option",
  },
];

export default function ServicePage() {
  const { addToCart } = useContext(CartContext);
  const [search, setSearch] = useState("");

  const filteredServices = services.filter((service) =>
    service.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold text-center mb-4">BOOK YOUR SERVICE</h1>
      <input
        type="text"
        placeholder="Search Services..."
        className="w-full p-2 border rounded mb-4"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <div className="grid md:grid-cols-3 gap-6">
        {filteredServices.map((service) => (
          <div key={service.id} className="bg-white p-4 rounded shadow-md">
            <h2 className="text-lg font-semibold">{service.title}</h2>
            <p className="text-blue-600 font-medium">
              (Service Code: {service.code})
            </p>
            <p className="text-gray-600 text-sm">{service.description}</p>
            <div className="flex justify-between items-center mt-4">
              <span className="text-xl font-bold">₹{service.price}</span>
              <button
                className="bg-blue-500 text-white p-2 rounded hover:bg-blue-700"
                onClick={() => addToCart(service)}
              >
                🛒
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
